export const LANGUAGE = 'lang';
export const AREAS = 'areas';
export const ORDERS_QUERY = 'ordersQuery';
